import React, { useState, useEffect } from "react";
import "../../scss/cookieConsent.scss";
import { useI18n } from "../../i18n/I18nProvider";
import {
    getStoredCookieConsent,
    saveCookieConsent,
    updateConsentMode,
} from "../../utils/analytics";

const CookieConsent: React.FC = () => {
    const { t } = useI18n();
    const [visible, setVisible] = useState(false);
    const [animateIn, setAnimateIn] = useState(false);
    const [hasChoice, setHasChoice] = useState(false);

    useEffect(() => {
        const consent = getStoredCookieConsent();
        setHasChoice(!!consent);

        if (!consent) {
            const timer = setTimeout(() => {
                setVisible(true);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => setAnimateIn(true));
                });
            }, 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    const openPreferences = () => {
        setVisible(true);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => setAnimateIn(true));
        });
    };

    const dismiss = (analytics: boolean) => {
        setAnimateIn(false);
        setTimeout(() => {
            saveCookieConsent(analytics);
            updateConsentMode(analytics);
            setHasChoice(true);
            setVisible(false);
        }, 450);
    };

    if (!visible) {
        return hasChoice ? (
            <button
                type="button"
                className="cookie-settings"
                onClick={openPreferences}
                aria-label={t("cookie_manage")}
            >
                {t("cookie_manage")}
            </button>
        ) : null;
    }

    return (
        <div
            className={`cookie-banner ${animateIn ? "cookie-banner--visible" : ""}`}
            role="dialog"
            aria-modal="false"
            aria-labelledby="cookie-consent-title"
            aria-describedby="cookie-consent-description"
        >
            <div className="cookie-banner__glow" />
            <div className="cookie-banner__card">
                <div className="cookie-banner__icon" aria-hidden="true">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
                        <circle cx="8.5" cy="8.5" r="1" fill="currentColor" />
                        <circle cx="10.5" cy="15.5" r="1" fill="currentColor" />
                        <circle cx="15.5" cy="13.5" r="1" fill="currentColor" />
                    </svg>
                </div>

                <div className="cookie-banner__body">
                    <h3 id="cookie-consent-title" className="cookie-banner__title">{t("cookie_title")}</h3>
                    <p id="cookie-consent-description" className="cookie-banner__text">
                        {t("cookie_text")}
                    </p>
                    <p className="cookie-banner__details">{t("cookie_details")}</p>
                </div>

                <div className="cookie-banner__actions">
                    <button
                        type="button"
                        className="cookie-banner__btn cookie-banner__btn--reject"
                        onClick={() => dismiss(false)}
                    >
                        {t("cookie_reject")}
                    </button>
                    <button
                        type="button"
                        className="cookie-banner__btn cookie-banner__btn--accept"
                        onClick={() => dismiss(true)}
                    >
                        {t("cookie_accept")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
